export default __webpack_public_path__ + "static/media/Unsaved.9ac216e6.svg";